import { Steps } from "primereact/steps";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { CheckUserExistByMobile } from "../../services/AccountService";
import { GetInvitationByInvitationId } from "../../services/InvitationService";

const ViewInvitation = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [getInvitation, setInvitation] = useState<any>(null);
  const [getNewUser, SetNewUser] = useState(true);
  const params = useParams();
  async function CheckUserExistByMobileAsync() {
    await CheckUserExistByMobile(getInvitation.phoneNumber).then((p) => {
      if (p.data.statusCode === 200) {
        SetNewUser(false);
      } else {
        SetNewUser(true);
      }
    });
  }
  async function GetInvitationByInvitationIdAsync() {
    await GetInvitationByInvitationId(params.id).then((p) => {
      console.log(p.data.data);
      setInvitation(p.data.data);
    });
  }
  useEffect(() => {
    if (params.id) {
      GetInvitationByInvitationIdAsync();
    }
  }, []);
  useEffect(() => {
    //console.log("getInvitation", getInvitation);

    if (getInvitation) {
      CheckUserExistByMobileAsync();
    }
  }, [getInvitation]);

  const itemsNewUser = [
    {
      label: "بررسی دعوتنامه",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationRequest");
      },
    },
    {
      label: "احراز هویت",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationRequest");
      },
    },
    {
      label: "تعیین کلمه عبور",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationPassword");
      },
    },
    {
      label: " پذیرش دعوتنامه",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationRequest");
      },
    },
  ];
  const itemsExistingUser = [
    {
      label: "احراز هویت",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationRequest");
      },
    },
    {
      label: " پذیرش دعوتنامه",
      command: (event: any) => {
        //navigate("/ViewInvitation/InvitationRequest");
      },
    },
  ];
  return (
    <>
      <div className="container mt-5 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 ">
        <Steps
          model={getNewUser ? itemsNewUser : itemsExistingUser}
          activeIndex={activeIndex}
          onSelect={(e) => setActiveIndex(e.index)}
          readOnly={false}
        />
        <div className="col-12">
          <Outlet context={setActiveIndex} />
        </div>

        {/* <div className="mt-5 d-flex col-12" style={{ color: "red" }}>
          <div className="col-6" style={{ paddingRight: 0 }}>
            <Button
              icon="pi pi-arrow-right"
              className="p-button-rounded p-button-secondary p-button-outlined"
              aria-label="Bookmark"
            />
          </div>
          <div dir="ltr" className="col-6">
            <Button
              icon="pi pi-arrow-left"
              className="ml-2 p-button-rounded p-button-secondary p-button-outlined"
              aria-label="Bookmark"
            />
          </div>
        </div> */}
      </div>
    </>
  );
};
export default ViewInvitation;
